<template>
  <div class="sub-basin">
    <div class="title">{{ data.name }}</div>
    <div class="content">
      <div class="select">
        <span>时间尺度：</span>
        <n-select v-model:value="params.target" size="small" :options="timeOptions" class="w160" @update:value="initData" />
        <span class="ml20">指标：</span>
        <n-select v-model:value="factor" size="small" :options="factorOptions" class="w160" @update:value="handleData" />
      </div>
      <div class="chart">
        <subBasinLine ref="subBasinLine" />  
      </div>
    </div>
  </div>
</template>

<script>
  import { Api } from '@/api/publicApi'
  import subBasinLine from '@/components/charts/subBasinLine.vue'
  const api = new Api()

  export default {
    props: ['data'],
    components: {
      subBasinLine
    },
    data() {
      return {
        params: {
          target: 'year',
          lyNo: this.data.id
        },
        factor: 'TN',
        timeOptions: [{ label: '年', value: 'year' }, { label: '月', value: 'month' }],
        factorOptions: [ { label: '总氮', value: 'TN' }, { label: '总磷', value: 'TP' }, { label: '产水量', value: 'W' } ],
        xAxis: [],
        yAxis: [],
        chartData: []
      }
    },
    mounted() {
      // this.$nextTick(() => {
      //   this.$refs.subBasinLine.initChart()
      // })
      this.initData();   
    },
    methods: {
      initData() {
        api.screen.simulationDataGet(this.params).then(res => {
          if (res.code == 200) {
            this.chartData = res.data;
            this.handleData();
          }
        })
      },
      handleData() {
        let name = '', color = '', unit = '';
        if (this.factor == 'TN') {
          name = '总氮';
          color = '#ff9700';
          unit = 'kg/ha';
          this.yAxis = this.chartData.map(item => (Number(item.zd)));
        }
        if (this.factor == 'TP') {
          name = '总磷';
          color = '#FFE3BA';
          unit = 'kg/ha';
          this.yAxis = this.chartData.map(item => (Number(item.zl)));
        }
        if (this.factor == 'W') {
          name = '产水量';
          color = '#43C2C3';
          this.params.target == 'year' ? unit = '10⁶ ✖ m³' : unit = '10⁴ ✖ m³';
          this.yAxis = this.chartData.map(item => (Number(item.sl)));
        }
        this.xAxis = this.chartData.map(item => (item.time));
        this.$nextTick(() => {
          this.$refs.subBasinLine.initChart(this.xAxis, this.yAxis, name, color, unit);
        })
        console.log('xAxis----->', this.xAxis);
        console.log('yAxis----->', this.yAxis);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sub-basin {
    width: 70rem;
    height: 42.65rem;
    color: #fff;
    .title {
      font-size: 18px;
      font-weight: bold;
    }
    .content {
      .select {
        margin: 20px 0;
        display: flex;
      }

      .chart {
        width: 100%;
        height: 350px;
      }
    }

    .ml20 {
      margin-left: 20px;
    }
    .w160 {
      width: 160px;
      vertical-align: bottom;
      margin-top: -3px;
    }
  }
</style>